/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BatchDeleteDimensionItemDto,
  BatchUpdateDimensionItemDto,
  BatchUploadRequest,
  BatchUploadReview1Payload,
  CreateDimensionItemDto,
  CsvReviewResponse,
  DimensionItemDto,
  DimensionItemFilterDto,
  DimensionItemPaginatedDto,
  DimensionItemsManagersUpdateDto,
  DimensionItemsStatusUpdateDto,
  SingleUpdateDimensionItemDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DimensionItemController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name GetDimensionItems
   * @request GET:/api/v1/dimension/{dimensionId}/item
   */
  getDimensionItems = (dimensionId: string, params: RequestParams = {}) =>
    this.http.request<DimensionItemDto[], any>({
      path: `/v1/dimension/${dimensionId}/item`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDimensionItemsPath = '/v1/dimension/${dimensionId}/item'
  static getDimensionItemsMethod = 'GET'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name BatchUpdateDimensionItems
   * @request PUT:/api/v1/dimension/{dimensionId}/item
   */
  batchUpdateDimensionItems = (
    dimensionId: string,
    data: BatchUpdateDimensionItemDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/${dimensionId}/item`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUpdateDimensionItemsPath = '/v1/dimension/${dimensionId}/item'
  static batchUpdateDimensionItemsMethod = 'PUT'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name CreateDimensionItem
   * @request POST:/api/v1/dimension/{dimensionId}/item
   */
  createDimensionItem = (
    dimensionId: string,
    data: CreateDimensionItemDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DimensionItemDto, any>({
      path: `/v1/dimension/${dimensionId}/item`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDimensionItemPath = '/v1/dimension/${dimensionId}/item'
  static createDimensionItemMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name BatchDeleteDimensionItems
   * @request DELETE:/api/v1/dimension/{dimensionId}/item
   */
  batchDeleteDimensionItems = (
    dimensionId: string,
    data: BatchDeleteDimensionItemDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/dimension/${dimensionId}/item`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchDeleteDimensionItemsPath = '/v1/dimension/${dimensionId}/item'
  static batchDeleteDimensionItemsMethod = 'DELETE'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name UpdateDimensionItem
   * @request PUT:/api/v1/dimension/{dimensionId}/item/{dimensionItemId}
   */
  updateDimensionItem = (
    dimensionId: string,
    dimensionItemId: string,
    data: SingleUpdateDimensionItemDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DimensionItemDto, any>({
      path: `/v1/dimension/${dimensionId}/item/${dimensionItemId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDimensionItemPath = '/v1/dimension/${dimensionId}/item/${dimensionItemId}'
  static updateDimensionItemMethod = 'PUT'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name UpdateDimensionItemsStatuses
   * @request PUT:/api/v1/dimension/{dimensionId}/item/status
   */
  updateDimensionItemsStatuses = (
    dimensionId: string,
    data: DimensionItemsStatusUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DimensionItemDto[], any>({
      path: `/v1/dimension/${dimensionId}/item/status`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDimensionItemsStatusesPath = '/v1/dimension/${dimensionId}/item/status'
  static updateDimensionItemsStatusesMethod = 'PUT'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name UpdateDimensionItemsManagers
   * @request PUT:/api/v1/dimension/{dimensionId}/item/managers
   */
  updateDimensionItemsManagers = (
    dimensionId: string,
    data: DimensionItemsManagersUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DimensionItemDto[], any>({
      path: `/v1/dimension/${dimensionId}/item/managers`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDimensionItemsManagersPath = '/v1/dimension/${dimensionId}/item/managers'
  static updateDimensionItemsManagersMethod = 'PUT'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name GetDimensionItemsByFilters
   * @request POST:/api/v1/dimension/{dimensionId}/item/filter
   */
  getDimensionItemsByFilters = (
    dimensionId: string,
    data: DimensionItemFilterDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DimensionItemPaginatedDto, any>({
      path: `/v1/dimension/${dimensionId}/item/filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getDimensionItemsByFiltersPath = '/v1/dimension/${dimensionId}/item/filter'
  static getDimensionItemsByFiltersMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name BatchUpload1
   * @request POST:/api/v1/dimension/{dimensionId}/item/batch-upload
   */
  batchUpload = (dimensionId: string, data: BatchUploadRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/dimension/${dimensionId}/item/batch-upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static batchUploadPath = '/v1/dimension/${dimensionId}/item/batch-upload'
  static batchUploadMethod = 'POST'
  /**
   * No description
   *
   * @tags dimension-item-controller
   * @name BatchUploadReview1
   * @request POST:/api/v1/dimension/{dimensionId}/item/batch-upload/review
   */
  batchUploadReview = (
    dimensionId: string,
    data: BatchUploadReview1Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvReviewResponse, any>({
      path: `/v1/dimension/${dimensionId}/item/batch-upload/review`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static batchUploadReviewPath = '/v1/dimension/${dimensionId}/item/batch-upload/review'
  static batchUploadReviewMethod = 'POST'
}
